/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { CheckCircle2, Download, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

/** Passo 5 — riepilogo, download di brand-config.json e uscita dal wizard. */
export const StepDone = ({ result, onDownload, onGoApp }) => (
  <div className="space-y-5 animate-fade-slide" data-testid="setup-panel-done">
    <div className="flex items-center gap-3">
      <div className="h-12 w-12 rounded-xl bg-success text-success-foreground flex items-center justify-center"><CheckCircle2 className="h-6 w-6" /></div>
      <div>
        <h2 className="font-display font-semibold text-lg">Configurazione completata</h2>
        <p className="text-sm text-muted-foreground">Il brand è stato applicato dinamicamente. {result?.file_written ? <>File scritto in <span className="font-mono">{result.file_written}</span>.</> : 'Scarica il file e copialo in frontend/public/.'}</p>
      </div>
    </div>
    <pre className="rounded-xl bg-muted/40 border border-border/70 p-3 text-[11px] font-mono max-h-64 overflow-auto scrollbar-thin" data-testid="setup-brand-config-preview">{JSON.stringify(result?.brand_config || {}, null, 2)}</pre>
    <div className="flex gap-2 flex-wrap">
      <Button onClick={onDownload} className="h-11 rounded-xl" data-testid="setup-download-config"><Download className="h-4 w-4" /> Scarica brand-config.json</Button>
      <Button variant="outline" onClick={onGoApp} className="h-11 rounded-xl" data-testid="setup-go-app">Vai all'app <ChevronRight className="h-4 w-4" /></Button>
    </div>
  </div>
);
